import { Grid, IconButton, Card, CardHeader, CardContent, Tooltip } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import { GridContainer, InfoText } from "components/common-styles"
import { useStores } from "stores/root-store"
import { formatStandardDate } from "utils/date-helper"

const DGItemProfileViewDetails = ({ onEditClicked }) => {
  const { DGItemProfileStore } = useStores()

  const detailInfo = { ...DGItemProfileStore.detailInfo }

  return (
    <Card>
      <CardHeader
        title="DG Item Profile"
        action={
          <Tooltip placement="top" title="Edit">
            <IconButton id="btnEdit" size="large" onClick={onEditClicked}>
              <EditIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        }
      />
      <CardContent>
        <GridContainer container spacing={3}>
          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Item
            </Grid>
            <Grid item xs={8}>
              <InfoText id="item">{detailInfo?.ITEM}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Active
            </Grid>
            <Grid item xs={7}>
              <InfoText id="active">{detailInfo?.ACTIVE}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              UN Number
            </Grid>
            <Grid item xs={8}>
              <InfoText id="un_number">{detailInfo?.UN_NUMBER}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              DG Volume
            </Grid>
            <Grid item xs={7}>
              <InfoText id="dg_volume">{detailInfo?.DG_VOLUME}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Class
            </Grid>
            <Grid item xs={8}>
              <InfoText id="class">{detailInfo?.CLASS}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Packing Group
            </Grid>
            <Grid item xs={7}>
              <InfoText id="packing_group">{detailInfo?.PACKING_GROUP}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Common Name
            </Grid>
            <Grid item xs={8}>
              <InfoText id="common_name">{detailInfo?.COMMON_NAME}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Techincal Name
            </Grid>
            <Grid item xs={7}>
              <InfoText id="technical_name">{detailInfo?.TECHNICAL_NAME}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Receptacle Volume
            </Grid>
            <Grid item xs={8}>
              <InfoText id="receptacle_volume">{detailInfo?.RECEPTACLE_VOLUME}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              ID 8000
            </Grid>
            <Grid item xs={7}>
              <InfoText id="id8000">{detailInfo?.ID8000}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Emergency Contact Name
            </Grid>
            <Grid item xs={8}>
              <InfoText id="contact_name">{detailInfo?.EMERGENCY_CONTACT_NAME}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Emergency Contact Phone
            </Grid>
            <Grid item xs={7}>
              <InfoText id="contact_phone">{detailInfo?.EMERGENCY_CONTACT_PHONE}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              MSDS File Name
            </Grid>
            <Grid item xs={8}>
              <InfoText id="file_name">{detailInfo?.MSDS_FILE_NAME}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={3} xs={12}>
            <Grid item xs={5}>
              MSDS Creation Date
            </Grid>
            <Grid item xs={7}>
              <InfoText id="creation_date">{formatStandardDate(detailInfo?.MSDS_CREATION_DATE)}</InfoText>
            </Grid>
          </Grid>
          <Grid item container md={3} xs={12}>
            <Grid item xs={5}>
              MSDS Expiry Date
            </Grid>
            <Grid item xs={7}>
              <InfoText id="expiry_date">{formatStandardDate(detailInfo?.MSDS_EXPIRY_DATE)}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Marine Pollutant
            </Grid>
            <Grid item xs={8}>
              <InfoText id="marine_pollutant">{detailInfo?.MARINE_POLLUTANT}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Personal Care
            </Grid>
            <Grid item xs={7}>
              <InfoText id="personal_care">{detailInfo?.PERSONAL_CARE}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Battery Weight
            </Grid>
            <Grid item xs={8}>
              <InfoText id="battery_weight">{detailInfo?.BATTERY_WEIGHT}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Lithium Battery
            </Grid>
            <Grid item xs={7}>
              <InfoText id="lithium_battery">{detailInfo?.LITHIUM_BATTERY}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Subsidary Risk
            </Grid>
            <Grid item xs={8}>
              <InfoText id="subsidary_risk">{detailInfo?.SUBSIDARY_RISK}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Flashpoint DEGC
            </Grid>
            <Grid item xs={7}>
              <InfoText id="flashpoint_degc">{detailInfo?.FLASHPOINT_DEGC}</InfoText>
            </Grid>
          </Grid>
        </GridContainer>
      </CardContent>
    </Card>
  )
}

export default DGItemProfileViewDetails
